import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { MainLayout } from 'src/layouts/main';
import { SimpleLayout } from 'src/layouts/simple';
import ProductListPage from 'src/pages/aktivite/list';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const FaqsPage = lazy(() => import('src/pages/faqs'));
const AboutPage = lazy(() => import('src/pages/about-us'));
const OurMissionPage = lazy(() => import('src/pages/our-mission'));
const HowItWorksPage = lazy(() => import('src/pages/how-it-works'));
const ForOrganizerPage = lazy(() => import('src/pages/for-organizer'));
const SssPage = lazy(() => import('src/pages/sss'));
const ConditionsPage = lazy(() => import('src/pages/conditions'));
const ProfilePage = lazy(() => import('src/pages/profile'));
const SettingsPage = lazy(() => import('src/pages/settings'));
const FavoritesPage = lazy(() => import('src/pages/favorites/list'));
const MessagesPage = lazy(() => import('src/pages/messages'));
const MyActivitiesPage = lazy(() => import('src/pages/my-activities'));
const ContactPage = lazy(() => import('src/pages/contact-us'));
const PricingPage = lazy(() => import('src/pages/pricing'));
const PaymentPage = lazy(() => import('src/pages/payment'));
const ComingSoonPage = lazy(() => import('src/pages/coming-soon'));
const MaintenancePage = lazy(() => import('src/pages/maintenance'));
// Product
// const ProductListPage = lazy(() => import('src/pages/aktivite/list'));
const ProductDetailsPage = lazy(() => import('src/pages/aktivite/details'));
const ProductCheckoutPage = lazy(() => import('src/pages/aktivite/checkout'));
// Blog
const PostListPage = lazy(() => import('src/pages/post/list'));
const PostDetailsPage = lazy(() => import('src/pages/post/details'));
// Error
const Page500 = lazy(() => import('src/pages/error/500'));
const Page403 = lazy(() => import('src/pages/error/403'));
const Page404 = lazy(() => import('src/pages/error/404'));
// Blank
const BlankPage = lazy(() => import('src/pages/blank'));

// ----------------------------------------------------------------------

export const mainRoutes: RouteObject[] = [
  {
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        element: (
          <MainLayout>
            <Outlet />
          </MainLayout>
        ),
        children: [
          { path: 'about-us', element: <AboutPage /> },
          { path: 'nasil-calisir', element: <HowItWorksPage /> },
          { path: 'misyonumuz', element: <OurMissionPage /> },
          { path: 'organizator-kaydi', element: <ForOrganizerPage /> },
          { path: 'sss', element: <SssPage /> },
          { path: 'conditions', element: <ConditionsPage /> },
          { path: 'profile', element: <ProfilePage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: 'favorites', element: <FavoritesPage /> },
          { path: 'messages', element: <MessagesPage /> },
          { path: 'my-activities', element: <MyActivitiesPage /> },
          { path: 'contact-us', element: <ContactPage /> },
          { path: 'faqs', element: <FaqsPage /> },
          { path: 'blank', element: <BlankPage /> },
          {
            path: 'aktivite',
            children: [
              { index: true, element: <ProductListPage /> },
              { path: 'list', element: <ProductListPage /> },
              { path: ':id', element: <ProductDetailsPage /> },
              { path: 'checkout', element: <ProductCheckoutPage /> },
            ],
          },
          {
            path: 'post',
            children: [
              { index: true, element: <PostListPage /> },
              { path: 'list', element: <PostListPage /> },
              { path: ':title', element: <PostDetailsPage /> },
            ],
          },
          {
            path: 'blog',
            children: [{ path: ':title', element: <ProductDetailsPage /> }],
          },
        ],
      },
      {
        path: 'pricing',
        element: (
          <SimpleLayout>
            <PricingPage />
          </SimpleLayout>
        ),
      },
      {
        path: 'payment',
        element: (
          <SimpleLayout>
            <PaymentPage />
          </SimpleLayout>
        ),
      },
      {
        path: 'coming-soon',
        element: (
          <SimpleLayout slotProps={{ content: { compact: true } }}>
            <ComingSoonPage />
          </SimpleLayout>
        ),
      },
      {
        path: 'maintenance',
        element: (
          <SimpleLayout slotProps={{ content: { compact: true } }}>
            <MaintenancePage />
          </SimpleLayout>
        ),
      },
      {
        path: 'error',
        children: [
          { path: '500', element: <Page500 /> },
          { path: '404', element: <Page404 /> },
          { path: '403', element: <Page403 /> },
        ],
      },
    ],
  },
];
